import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'

import Button from '../components/common/Button'
import ButtonBack from '../components/layout/ButtonBack/ButtonBack'
import Layout from '../components/layout/Layout'
import Price from '../components/voucher/Price/Price'
import VoucherPanel from '../components/VoucherPanel/VoucherPanel'
import { getSummary, hasVouchers } from '../selectors/selectors'
import s from './VoucherPage.module.scss'

export default function VoucherPage() {
  const { t } = useTranslation()
  const history = useHistory()
  const { price, regularPrice, loading } = useSelector(getSummary)
  const hasAddedVouchers = useSelector(hasVouchers)
  const discount = price - regularPrice
  const priceVisible = hasAddedVouchers && !loading

  return (
    <Layout pageTitle={t('mainPage.title')}>
      <div className={s['voucher-page']}>
        <ButtonBack />
        <VoucherPanel onCancelAddNewVoucher={() => !hasAddedVouchers && history.goBack()} />
        {priceVisible && <Price discount={discount} price={price} regularPrice={regularPrice} />}
        {hasAddedVouchers && (
          <div className={s['button-done']}>
            <Button className="button-primary-sm" onClick={() => history.goBack()}>
              {t('common.done')}
            </Button>
          </div>
        )}
      </div>
    </Layout>
  )
}
